module.exports = __webpack_public_path__ + "img/img-b8533b1a.dfdf6399.png";